import React, { createContext, useReducer, useContext, useMemo } from 'react';

export const EditorContext = createContext(null);
export const EditorDispatchContext = createContext(null);

const initialEditor = {
	isEditMode: false,
	isRotate: false,
	isCrop: false,
	isCropMode: false,
	isBright: false,
	isBrightnessMode: false,
	isUpdate: false,
	showFilterButton: false,
	showDescription: false,
	navDirection: 'next',
	editIdx: 0,
	brightness: 0,
};

function editorReducer(editor, action) {
	switch (action.type) {
		case 'SET_EDIT_IMG': {
			return {
				...editor,
				isCrop: false,
				isBright: false,
				isRotate: false,
				isEditMode: true,
				showDescription: true,
				editIdx: action.index,
				showFilterButton: true,
				brightness: 0,
			};
		}

		case 'RESET_EDITOR': {
			return {
				...editor,
				isCrop: false,
				isBright: false,
				isRotate: false,
				showDescription: true,
				brightness: 0,
			};
		}

		case 'SET_BRIGHTNESS': {
			return {
				...editor,
				isUpdate: true,
				isBright: true,
				brightness: action.value,
				isBrightnessMode: false,
				showFilterButton: true,
				showDescription: true,
			};
		}

		case 'SET_CROP': {
			return {
				...editor,
				isUpdate: true,
				isCrop: true,
				isCropMode: false,
				showFilterButton: true,
				showDescription: true,
			};
		}

		case 'SET_ROTATE': {
			return {
				...editor,
				isUpdate: true,
				isRotate: true,
				showFilterButton: true,
			};
		}

		case 'SET_TEMP': {
			return {
				...editor,
				isUpdate: false,
				isCrop: false,
				isBright: false,
				isRotate: false,
				isEditMode: false,
				showFilterButton: false,
				isCropMode: false,
				isBrightnessMode: false,
			};
		}

		case 'TOGGLE_FILTER_BTN': {
			return {
				...editor,
				isCropMode: !editor.isCropMode,
				isBrightnessMode: !editor.isBrightnessMode,
				showFilterButton: !editor.showFilterButtons,
			};
		}

		case 'TOGGLE_CROP_MODE': {
			return {
				...editor,
				showFilterButton: !editor.showFilterButton,
				isCropMode: !editor.isCropMode,
				showDescription: !editor.showDescription,
			};
		}

		case 'TOGGLE_BRIGHTNESS_MODE': {
			return {
				...editor,
				showFilterButton: !editor.showFilterButton,
				isBrightnessMode: !editor.isBrightnessMode,
				showDescription: !editor.showDescription,
			};
		}

		case 'CLOSE_EDIT_MODE': {
			return {
				...editor,
				isUpdate: false,
				isRotate: false,
				isBright: false,
				isCrop: false,
				isEditMode: false,
				showDescription: false,
				showFilterButton: false,
				brightness: 0,
			};
		}

		default: {
			throw Error(`Unknown action: ${action.type}`);
		}
	}
}

export const EditorProvider = ({ children }) => {
	const [editor, dispatch] = useReducer(editorReducer, initialEditor);
	const editorState = useMemo(() => editor, [editor]); // context 최적화
	return (
		<EditorContext.Provider value={{ editor: editorState, dispatchEditor: dispatch }}>
			<EditorDispatchContext.Provider value={dispatch}>{children}</EditorDispatchContext.Provider>
		</EditorContext.Provider>
	);
};

export const useEditor = () => useContext(EditorContext);
export const useEditorDispatch = () => useContext(EditorDispatchContext);

export default EditorProvider;

